import React, { useContext } from 'react';
import { DataContext } from '../../../stores/covering-table-store';
import Toast from 'react-bootstrap/Toast';

const CoveringToasts = (props) => {
    const {
        store: { isSavedToastOpen, isDeletedToastOpen },
        dispatch,
    } = useContext(DataContext);

    const delay = 5 * 1000;

    const onSavedToastClose = () => {
        dispatch({ type: 'CLOSE_SAVED_TOAST' });
    };

    const onDeletedToastClose = () => {
        dispatch({ type: 'CLOSE_DELETED_TOAST' });
    };

    return (
        <div className='covering-toasts'>
            <SavedToast {...{ delay, isOpen: isSavedToastOpen, onClose: onSavedToastClose }} />
            <DeletedToast {...{ delay, isOpen: isDeletedToastOpen, onClose: onDeletedToastClose }} />
        </div>
    );
};

export default CoveringToasts;

const SavedToast = ({ delay, isOpen, onClose }) => {
    return (
        <Toast className='bg-success' onClose={onClose} show={isOpen} delay={delay} autohide>
            <Toast.Body>
                <div className='oi oi-check'></div>
                <div>Sparad</div>
            </Toast.Body>
        </Toast>
    );
};

const DeletedToast = ({ delay, isOpen, onClose }) => {
    return (
        <Toast className='bg-success' onClose={onClose} show={isOpen} delay={delay} autohide animation>
            <Toast.Body>
                <div className='oi oi-check'></div>
                <div>Raderad</div>
            </Toast.Body>
        </Toast>
    );
};
